export function initChapterNews() {
  const PER_PAGE = 6;

  let allDocs = [];
  let visibleCount = PER_PAGE;
  let debounceTimer = null;

  function getThemeUrl() {
    const link = document.querySelector(
      'link[rel="stylesheet"][href*="/wp-content/themes/"]',
    );
    if (!link) return "";
    const match = link.href.match(/(.*\/wp-content\/themes\/[^/]+)/);
    return match ? match[1] : "";
  }

  const THEME_URL = getThemeUrl();
  const FALLBACK_IMAGE = `${THEME_URL}/resources/images/bpa-logo-general.svg`;
  const SEARCH_ICON = `${THEME_URL}/resources/images/search-icon-black.svg`;
  const CLOSE_ICON = `${THEME_URL}/resources/images/red-close-btn-with-white-bg.svg`;

  const grid = document.getElementById("news-cards-grid");
  const searchInput = document.getElementById("news-search-input");
  const chipContainer = document.getElementById("news-chip-container");
  const chipsWrapper = document.getElementById("news-chips-wrapper");
  const clearAllBtn = document.getElementById("news-clear-all");
  const resultsCount = document.getElementById("news-results-count");
  const pagination = document.getElementById("news-pagination");
  const loadMoreBtn = document.getElementById("news-load-more");
  const showLessBtn = document.getElementById("news-show-less");

  if (!grid || !searchInput) return;

  // ── Loader
  function showLoader() {
    grid.innerHTML = `
      <div class="w-full flex flex-col items-center justify-center gap-4 py-10 col-span-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24">
          <g stroke="#C8102E" stroke-width="1">
            <circle cx="12" cy="12" r="9.5" fill="none" stroke-linecap="round" stroke-width="3">
              <animate attributeName="stroke-dasharray" calcMode="spline" dur="1.5s"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1"
                repeatCount="indefinite" values="0 150;42 150;42 150;42 150" />
              <animate attributeName="stroke-dashoffset" calcMode="spline" dur="1.5s"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1"
                repeatCount="indefinite" values="0;-16;-59;-59" />
            </circle>
            <animateTransform attributeName="transform" dur="2s" repeatCount="indefinite" type="rotate"
              values="0 12 12;360 12 12" />
          </g>
        </svg>
        <span class="text-brand-black font-neutraface text-[1.25rem] font-normal">Loading News...</span>
      </div>`;
    pagination.classList.add("hidden");
  }

  // ── API
  function buildUrl(query) {
    return (
      `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/news/documents/search?` +
      new URLSearchParams({
        q: query || "*",
        query_by: "title,post_title,content,text,date,article_types_names",
        sort_by: "post_title:asc",
        per_page: 250,
        page: 1,
        num_typos: 0,
        prefix: false,
      })
    );
  }

  async function fetchNews(query) {
    const res = await fetch(buildUrl(query), {
      headers: {
        "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY,
      },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return data.hits?.map((hit) => hit.document) || [];
  }

  // ── Card template
  function renderCard(doc) {
    const hasFeaturedImage =
      doc.featured_image && doc.featured_image.trim() !== "";
    const imgSrc = hasFeaturedImage ? doc.featured_image : FALLBACK_IMAGE;
    const imgClass = hasFeaturedImage
      ? "w-full h-full object-contain md:object-cover object-center md:object-top"
      : "w-full h-full object-contain object-center";

    const typeChips = (doc.article_types_names || [])
      .map(
        (name) => `
        <span class="w-auto pb-[.0625rem] pt-[.1875rem] px-[.375rem] bg-brand-light-blue rounded text-[.8125rem] leading-[1.375rem] font-normal text-brand-dark-blue tracking-[.0406rem] uppercase">
          ${name}
        </span>`,
      )
      .join("");

    return `
      <a href="${doc.permalink}"
        class="w-full gridBox-three transform transition-transform duration-300 ease-in-out hover:scale-[1.01] flex flex-col no-underline">
        <div class="w-full !h-[15rem] md:!h-[21.03rem] bg-brand-light-blue overflow-hidden">
          <img src="${imgSrc}" alt="${doc.post_title || doc.title || ""}" class="${imgClass}">
        </div>
        <div class="w-full flex flex-col items-center md:items-start gap-2 md:gap-3 flex-1 p-4 lg:p-6 bg-white border-t-[.5rem] border-brand-warm-beige">
          <div class="flex flex-wrap gap-1">${typeChips}</div>
          <h3 class="w-full text-h3 font-josefin text-brand-dark-blue font-normal text-center md:text-start !my-0">
            ${doc.post_title || ""}
          </h3>
          <p class="w-full text-p1 text-brand-black font-normal text-center md:text-start">
            ${doc.date || ""}
          </p>
        </div>
      </a>`;
  }

  // ── Render visible slice
  function renderCards() {
    const visible = allDocs.slice(0, visibleCount);
    grid.innerHTML = visible.length
      ? visible.map(renderCard).join("")
      : '<p class="text-brand-black font-neutraface text-p1 col-span-6">No results found.</p>';

    const hasMore = allDocs.length > visibleCount;
    const hasLess = visibleCount > PER_PAGE;

    pagination.classList.toggle("hidden", !hasMore && !hasLess);
    loadMoreBtn.classList.toggle("hidden", !hasMore);
    showLessBtn.classList.toggle("hidden", !hasLess);
  }

  // ── Chips + results count
  function updateFilterUI(query) {
    const hasQuery = query.trim().length > 0;

    chipContainer.classList.toggle("hidden", !hasQuery);
    resultsCount.classList.toggle("hidden", !hasQuery);

    if (hasQuery) {
      chipsWrapper.innerHTML = `
        <span class="flex items-center gap-2 py-1 px-3 border border-brand-dark-red bg-brand-dark-red rounded-full text-p1 text-white font-neutraface">
          ${query}
          <button type="button" id="news-chip-close-btn" class="w-[1.875rem] h-[1.875rem]">
            <img src="${CLOSE_ICON}" alt="close" class="w-full h-full">
          </button>
        </span>`;

      document
        .getElementById("news-chip-close-btn")
        .addEventListener("click", function (e) {
          e.stopPropagation();
          newsClearSearch();
        });

      resultsCount.textContent = `${allDocs.length} Result${allDocs.length !== 1 ? "s" : ""}`;
    }
  }

  // ── Scroll to grid with breakpoint offset
  function scrollToGrid() {
    const offset = window.innerWidth >= 1024 ? 60 : 25;
    const gridTop = grid.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: gridTop - offset,
      behavior: "smooth",
    });
  }

  // ── Main search handler
  async function doSearch(query) {
    visibleCount = PER_PAGE;
    showLoader();
    try {
      // allDocs = await fetchNews(query);
      const rawDocs = await fetchNews(query);
      allDocs = rawDocs.filter(
        (doc) =>
          Array.isArray(doc.article_types_names) &&
          doc.article_types_names.includes("Chapter News"),
      );
      renderCards();
      updateFilterUI(query);
    } catch (err) {
      grid.innerHTML =
        '<p class="text-brand-black font-neutraface text-p1">Something went wrong. Please try again.</p>';
      console.error("Typesense fetch failed:", err);
    }
  }

  // ── Clear search
  window.newsClearSearch = function () {
    searchInput.value = "";
    doSearch("");
  };

  // ── Events
  searchInput.addEventListener("input", function () {
    const query = this.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => doSearch(query), 350);
  });

  clearAllBtn.addEventListener("click", function (e) {
    e.preventDefault();
    newsClearSearch();
  });

  loadMoreBtn.addEventListener("click", function () {
    visibleCount += PER_PAGE;
    renderCards();
  });

  showLessBtn.addEventListener("click", function () {
    visibleCount = PER_PAGE;
    renderCards();
    scrollToGrid();
  });

  // ── Initial load
  doSearch("");
}

document.addEventListener("DOMContentLoaded", () => {
  initChapterNews();
});
